import React from 'react';
import { App } from '@mb/App';
import { createRoot } from 'react-dom/client';

import { ThemeContainer } from 'ui-widgets';
import { AppContainer } from '../../../pages/Banners/containers/AppContainer';

const BannersApp = () => {
  return (
    <App>
      <ThemeContainer>
        <AppContainer />
      </ThemeContainer>
    </App>
  );
};

const container = document.getElementById('bannersContent');
const root = createRoot(container!);
root.render(<BannersApp />);
